import axiosInstance from "../services/api.service";

export const fetchAllPayouts = async () => {
	const response = await axiosInstance.get("/api/v1/payout");

	return response?.data?.data;
};

export const fetchAllActivities = async () => {
	const response = await axiosInstance.get("/api/v1/activity");

	return response?.data?.data;
};
